import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../Context';
import { withStyles } from '@material-ui/core/styles';
import { FormControlLabel, Checkbox, Button, ExpansionPanel, Switch, ExpansionPanelSummary, Badge, ExpansionPanelDetails, Grid, Typography, CircularProgress, Divider } from '@material-ui/core/';
import CampaignDetailsStyles from '../../Styles/CampaignDetailsStyles';
import Moment from 'react-moment';
import { Mixpanel } from '../../Config/mixpanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PostDetails from '../PostDetails';
import ResultPostDetails from '../ResultPostDetails';
import AcceptPostsDialog from '../AcceptPostsDialog';

import './styles.css';

class CampaignDetails extends React.Component {
	constructor() {
		super();

		this.state = {
			acceptPostsDialogOpen: false
		}

		this.handlePostUpdate = this.handlePostUpdate.bind(this);
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		Mixpanel.track('Viewed page CampaignDetails', { campaignId: this.props.campaign._id });

		const actionRequiredPosts = this.props.campaign.posts.filter(p => { return (!p.repost && !p.makeStory && !p.promote && !p.rejected) });
		if (actionRequiredPosts.length > 0 && !this.props.campaign.autopilot && !this.context.state.loading) {
			this.setState({ acceptPostsDialogOpen: true });
		}
	}

	handlePostUpdate(postId, updateQuery) {
		this.context.actions.updateAdvertiserCampaignPost(this.props.campaign._id, postId, updateQuery);
	}

	handleChange = name => event => {
		if (name === 'autopilot') {
			this.setState({ acceptPostsDialogOpen: false });
			this.context.actions.updateAdvertiserCampaign(this.props.campaign._id, { autopilot: !this.props.campaign.autopilot });
			return;
		}
		// if (name === 'post' || name === 'story' || name === 'video') {
		// 	let fieldName = 'promotionType.' + name;
		// 	this.context.actions.updateAdvertiserCampaign(this.props.campaign._id, { '$set': { [fieldName]: !this.props.campaign.promotionType[name] } });
		// }

	}

	handleDialogClose = event => {
		this.setState({
			acceptPostsDialogOpen: false
		});
	}

	handleDialogOpen = event => {
		this.setState({
			acceptPostsDialogOpen: true
		});
	}


	render() {
		const { classes } = this.props;
		const { campaign } = this.state;

		let hashtags = campaign.hashtagsAndMentions ? campaign.hashtagsAndMentions : 'Let the people decide';

		// campaign statuses: ['Draft', 'In review', 'Approve posts', 'Running', 'Finished', 'Cancelled']
		// posts statuses: ['Repost', 'Boost', 'Make a story', 'Rejected'],

		const actionRequiredPosts = campaign.posts.filter(p => { return (!p.repost && !p.makeStory && !p.promote && !p.rejected) });
		const approvedPosts = campaign.posts.filter(p => { return (p.repost || p.makeStory || p.promote) });
		const rejectedPosts = campaign.posts.filter(p => p.rejected);

		const showActions = campaign.status !== 'Finished' && campaign.status !== 'Cancelled';
		const showResults = campaign.status === 'Finished';
		const showTempResults = campaign.resultPosts && campaign.resultPosts.length > 0;

		const totalImpressions = campaign.resultPosts.reduce((a, result) => a + (result.impressions ? result.impressions : 0), 0);
		const totalEngagement = campaign.resultPosts.reduce((a, result) => a + (result.engagement ? result.engagement : 0), 0);
		const totalClicks = campaign.resultPosts.reduce((a, result) => a + (result.clicksFromProfile ? result.clicksFromProfile : 0), 0);
		const totalBudgetSpent = campaign.resultPosts.reduce((a, result) => a + (result.cost ? result.cost : 0), 0);

		return (
			<div>
				{this.state.loading
					? (<CircularProgress size={24} className={classes.progress} />)
					: (
						<div>
							<AcceptPostsDialog open={this.state.acceptPostsDialogOpen} handleChange={this.handleChange} handleDialogClose={this.handleDialogClose} campaign={campaign} actionRequiredPosts={actionRequiredPosts} updateAction={this.handlePostUpdate} />
							<Typography variant='h5' className={classes.typography}>Campaign name: {campaign.name}</Typography>
							<Divider />
							<div style={{ padding: 10 }}>
								<ExpansionPanel>
									<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
										<div className="expansion-panel-summary-flex">
											<div className={classes.column}>
												<Typography className={classes.heading}>Status: {campaign.status ? campaign.status : 'Draft'}</Typography>
											</div>
											<div className={classes.column}>
												<Typography className={classes.secondaryHeading}>Start date: <Moment format='MMMM Do YYYY'>
													{campaign.goLiveDate}
												</Moment></Typography>
											</div>
											<div className={classes.column}>
												<Typography className={classes.secondaryHeading}>End data:
													{!campaign.continuous && <Moment format='MMMM Do YYYY'>
														{" "}{campaign.endDate}
													</Moment>
													}
													{campaign.continuous && ' N/A'}
												</Typography>
											</div>
											<div className={classes.column}>
												<Typography className={classes.secondaryHeading}>Budget: £{campaign.budget.budget ? campaign.budget.budget : 'TBD'}</Typography>
											</div>
										</div>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										<Grid container spacing={2}>
											<Grid item xs={12} sm={6} md={4}>
												<Typography variant='body1' className={classes.typography}>
													Followers: {parseInt(campaign.followers.min / 1000)}K - {parseInt(campaign.followers.max / 1000)}K
												</Typography>
											</Grid>
											<Grid item xs={12} sm={6} md={4}>
												<Typography variant='body1' className={classes.typography}>
													Hashtags and Mentions: {hashtags}
												</Typography>
											</Grid>
											<Grid item xs={12} sm={6} md={4}>
												<Typography variant='body1' className={classes.typography}>
													Send gift: {campaign.sendGift ? <span>Yes</span> : <span>No</span>}
												</Typography>
											</Grid>
											<Grid item xs={12} sm={6} md={4}>
												<Typography variant='body1' className={classes.typography}>
													<FormControlLabel
														control={
															<Checkbox
																disabled
																checked={campaign.promotionType && campaign.promotionType.post}
																color="primary"
															/>
														}
														label='Promote by post'
													/>
												</Typography>
											</Grid>
											<Grid item xs={12} sm={6} md={4}>
												<Typography variant='body1' className={classes.typography}>
													<FormControlLabel
														control={
															<Checkbox
																disabled
																checked={campaign.promotionType && campaign.promotionType.story}
																color="primary"
															/>
														}
														label='Promote by story'
													/>
												</Typography>
											</Grid>
											<Grid item xs={12} sm={6} md={4}>
												<Typography variant='body1' className={classes.typography}>
													<FormControlLabel
														control={
															<Checkbox
																disabled
																checked={campaign.promotionType && campaign.promotionType.video}
																color="primary"
															/>
														}
														label='Promote by video'
													/>
												</Typography>
											</Grid>

											<Grid item xs={12} sm={6} md={4}>
												<Typography variant='body1' className={classes.typography}>
													Campaign URL: {campaign.campaignURL ? campaign.campaignURL : ''}
												</Typography>
											</Grid>

											<Grid item xs={12} sm={6} md={4}>
												<Typography variant='body1' className={classes.typography}>
													Using Vimma Budget Optimisation: {campaign.autopilot ? <span>Yes</span> : <span>No</span>}
												</Typography>
											</Grid>

											<Grid item xs={12} sm={12}>
												<Typography variant='body1' className={classes.typography}>
													Brief: <br /> <span style={{ paddingLeft: '4px' }}>{campaign.brief ? campaign.brief : ''}</span>
												</Typography>
											</Grid>
											{campaign.targetDemographics && (
												<React.Fragment>
													<Grid item xs={12}>
														<Divider></Divider>
														<Typography variant='body1' className={classes.typography}>
															Demographics:
												</Typography>
													</Grid>
													<Grid item xs={12} sm={6} md={4}>
														<Typography variant='body1' className={classes.typography}>
															Countries: {campaign.targetDemographics.countries.join(', ')}
														</Typography>
													</Grid>
													<Grid item xs={12} sm={6} md={4}>
														<Typography variant='body1' className={classes.typography}>
															Interests: {campaign.targetDemographics.interests.join(', ')}
														</Typography>
													</Grid>
													<Grid item xs={12} sm={6} md={4}>
														<Typography variant='body1' className={classes.typography}>
															Additional Info: {campaign.targetDemographics.additionalInfo}
														</Typography>
													</Grid>
												</React.Fragment>
											)}
										</Grid>
									</ExpansionPanelDetails>
								</ExpansionPanel>
							</div>
							<Divider />
							{showActions && (<div>
								<Typography variant='h5' className={classes.typography}>Creators and results</Typography>
								<div style={{ padding: 10 }}>
									{!campaign.autopilot && (
										<div>
											{actionRequiredPosts.length > 0 && (
												<div style={{ textAlign: 'center' }}>
													<Typography variant='h5' className={classes.typography}>
														Great, you have creators that need to be approved!
													</Typography>
													<Badge color="primary" badgeContent={actionRequiredPosts.length} className={classes.badgeMargin}>
														<Button variant="contained" size="large" color="primary" onClick={this.handleDialogOpen} >
															Approve creators
														</Button>
													</Badge>
													<Typography variant='h5' className={classes.typography}>
														- Or -
													</Typography>
													<Typography variant='h5' className={classes.typography}>
														<Switch
															checked={campaign.autopilot}
															onChange={this.handleChange('autopilot')}
														/>
														Turn on Vimma Budget Optimisation for the campaign
													</Typography>
												</div>
											)}
											<ExpansionPanel>
												<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
													<div className={classes.column}>
														<Typography className={classes.heading}>Approved posts</Typography>
													</div>
													<div className={classes.column}>
														<Typography className={classes.secondaryHeading}>{approvedPosts.length} post(s) approved</Typography>
													</div>
												</ExpansionPanelSummary>
												<ExpansionPanelDetails>
													<Grid container spacing={2}>
														{approvedPosts.map((p) => (
															<Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={p.post.id}>
																<PostDetails post={p} updateAction={this.handlePostUpdate} />
															</Grid>))}
														{!approvedPosts && (<Grid item xs={12}>
															<div className={classes.center}>
																<Typography variant='body1' className={classes.typography}>Nothing to show here</Typography>
															</div>
														</Grid>)}
													</Grid>
												</ExpansionPanelDetails>
											</ExpansionPanel>
											<ExpansionPanel>
												<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
													<div className={classes.column}>
														<Typography className={classes.heading}>Rejected posts</Typography>
													</div>
													<div className={classes.column}>
														<Typography className={classes.secondaryHeading}>{rejectedPosts.length} post(s) rejected</Typography>
													</div>
												</ExpansionPanelSummary>
												<ExpansionPanelDetails>
													<Grid container spacing={2}>
														{rejectedPosts.map((p) => (
															<Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={p.post.id}>
																<PostDetails post={p} updateAction={this.handlePostUpdate} showActions={true} />
															</Grid>))}
														{!rejectedPosts && (<Grid item xs={12}>
															<div className={classes.center}>
																<Typography variant='body1' className={classes.typography}>Nothing to show here</Typography>
															</div>
														</Grid>)}
													</Grid>
												</ExpansionPanelDetails>
											</ExpansionPanel>
										</div>)}
									{campaign.autopilot && (
										<div className={classes.center}>
											<Typography variant='h5' className={classes.typography}>This campaign is using Vimma Budget Optimisation</Typography>
											<Typography variant='body1' className={classes.typography}>
												<Switch
													checked={campaign.autopilot}
													onChange={this.handleChange('autopilot')}
												/>
												Turn off Vimma Budget Optimisation mode
											</Typography>
										</div>
									)}
								</div>
							</div>)}
							{showResults && (<div>
								<Typography variant='h5' className={classes.typography}>Campaign Results</Typography>
								<ExpansionPanel defaultExpanded>
									<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
										<div className={classes.column}>
											<Typography className={classes.heading}>Budget spent: £{(totalBudgetSpent).toFixed(2)}</Typography>
										</div>
										<div className={classes.column}>
											<Typography className={classes.secondaryHeading}>Impressions: {(totalImpressions / 1000).toFixed(1)}K</Typography>
										</div>
										<div className={classes.column}>
											<Typography className={classes.secondaryHeading}>Engagement: {(totalEngagement / 1000).toFixed(1)}K</Typography>
										</div>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										<Grid container spacing={2}>
											<Grid item xs={12} sm={6}>
												<Typography variant="h6">Spend</Typography>
												<Typography variant='body1'>Campaign bugdet: £{(campaign.budget.budget).toFixed(2)}</Typography>
												<Typography variant='body1'>Total budget spent: £{(totalBudgetSpent).toFixed(2)}</Typography>
											</Grid>
											<Grid item xs={12} sm={6}>
												<Typography variant="h6">Impressions</Typography>
												<Typography variant='body1'>Total impressions: {totalImpressions}</Typography>
												<Typography variant='body1'>CPI: £{(totalBudgetSpent / totalImpressions).toFixed(4)}</Typography>
											</Grid>
											<Grid item xs={12} sm={6}>
												<Typography variant="h6">Engagement</Typography>
												<Typography variant='body1'>Total engagement: {totalEngagement}</Typography>
												<Typography variant='body1'>CPE: £{(totalBudgetSpent / totalEngagement).toFixed(4)}</Typography>
											</Grid>
											<Grid item xs={12} sm={6}>
												<Typography variant="h6">Clicks</Typography>
												<Typography variant='body1'>Total clicks: {totalClicks ? totalClicks : 'N/A'}</Typography>
												<Typography variant='body1'>CPC: {totalClicks ? `£${(totalBudgetSpent / totalClicks).toFixed(4)}` : 'N/A'}</Typography>
											</Grid>
										</Grid>
									</ExpansionPanelDetails>
								</ExpansionPanel>
								<ExpansionPanel>
									<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
										<div className={classes.column}>
											<Typography className={classes.heading}>Performance per post</Typography>
										</div>
										<div className={classes.column}>
											<Typography className={classes.secondaryHeading}>{campaign.resultPosts.length} post(s)</Typography>
										</div>
									</ExpansionPanelSummary>
									<ExpansionPanelDetails>
										<Grid container spacing={2}>
											{campaign.resultPosts.map((p, index) => (
												<Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={index}>
													<ResultPostDetails post={p} />
												</Grid>)
											)}
										</Grid>
									</ExpansionPanelDetails>
								</ExpansionPanel>
							</div>)}
							{(showTempResults && !showResults) && (
								<div style={{ padding: 10 }}>
									<ExpansionPanel>
										<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
											<div className={classes.column}>
												<Typography className={classes.heading}>Campaign Results Preview</Typography>
											</div>
											<div className={classes.column}>
												<Typography className={classes.secondaryHeading}>{campaign.resultPosts.length} post(s)</Typography>
											</div>
										</ExpansionPanelSummary>
										<ExpansionPanelDetails>
											<Grid container spacing={2}>
												{campaign.resultPosts.map((p) => (
													<Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={p._id ? p._id : p.post.shortcode}>
														<ResultPostDetails post={p} />
													</Grid>)
												)}
											</Grid>
										</ExpansionPanelDetails>
									</ExpansionPanel>
								</div>
							)}
						</div>
					)
				}
			</div>
		);
	}
}

CampaignDetails.propTypes = {
	classes: PropTypes.object.isRequired
};

CampaignDetails.contextType = Context;

export default withStyles(CampaignDetailsStyles)(CampaignDetails);
